<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Ativas na Semana</h3>
        </div>
        <div class="col text-right">
          <base-button size="sm" type="primary">Ver Todos</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <el-table
        class="table-responsive table"
        :data="tableData"
        header-row-class-name="thead-light"
      >
        <el-table-column label="Unidade" min-width="115px" prop="name">
          <template v-slot="{row}">
            <div class="font-weight-600">{{row.name}}</div>
          </template>
        </el-table-column>

        <el-table-column label="Ativo em" min-width="110px" prop="visitors"></el-table-column>

        <el-table-column min-width="220px" prop="progress">
          <template v-slot="{row}">
            <div class="d-flex align-items-center">
              <i class="fas fa-arrow-up text-success mr-3 text-success"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { BaseProgress } from "@/components";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "social-traffic-table",
  components: {
    BaseProgress,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  data() {
    return {
      tableData: [
        {
          name: "Unidade 232",
          visitors: "10/11/2020"
        }
      ]
    };
  }
};
</script>
<style>
</style>
